import React from "react";
import {
    Row,
    Col,
    Input,
    InputGroup,
    InputGroupText,
    Badge
} from "reactstrap";
import {
    HelpCircle,
    User,
    CheckCircle
} from "react-feather";
import image from "../public/EventIcon.jpg"


const FAQHeader = ({ registrationId }) => {
    return (
        <>
            {/* Top Icon */}
            <Row className="mb-4">
                <Col className="text-center">

                    <div
                        className="d-inline-flex justify-content-center align-items-center rounded-circle bg-primary text-white shadow"
                    >
                        <img src={image} alt="" className="img-fluid" />
                    </div>

                    <h2 className="fw-bold mt-3 mb-2">
                        Interactive FAQs Session
                    </h2>

                    <p className="text-muted mb-3">
                        Answer each question before the timer expires.
                        Once submitted, your answer cannot be changed.
                    </p>

                    <Badge color="success" pill className="px-3 py-2">
                        Live Session
                    </Badge>

                </Col>
            </Row>

            {/* Registration ID */}
            <Row className="justify-content-center mb-4">

                <Col md="8">

                    <label className="fw-bold mb-2">
                        Registration ID
                    </label>

                    <InputGroup>

                        <InputGroupText>
                            <User size={18} />
                        </InputGroupText>

                        <Input
                            type="text"
                            // readOnly
                            // value={registrationId || "Loading..."}
                            className="fw-bold bg-light"
                        />

                        <InputGroupText className="bg-success text-white">
                            <CheckCircle size={18} />
                        </InputGroupText>

                    </InputGroup>

                </Col>

            </Row>

            <hr className="mb-4" />
        </>
    );
};

export default FAQHeader;